import type {Recipe} from './types';

export const polloAlPesto: Recipe = {
    id: 17,
    key: "polloAlPesto",
    pictures: [
        {index: 0, url: "https://blog.giallozafferano.it/chezbibia/wp-content/uploads/2019/04/bocconcini-di-pollo-al-pesto-1200x900.jpg"},
    ],
    video: "https://youtu.be/G1FC5eB3bvs?si=DyQ4SpufFD8i1alU",
    i18n: {
        IT: {
            title: "Pollo al Pesto",
            servings: "2 persone",
            ingredients: [
                "Due petti di pollo grandi",
                "Un po' di latte",
                "Pesto Barilla (vasetto)",
                "Olio d'oliva",
                "Sale",
            ],
            steps: [
                "Tagliare il pollo a fette non troppo grosse e grandi (eventualmente batterlo leggermente per ammorbidirlo).",
                "Soffriggere con un po' d'olio a fuoco medio fino a doratura.",
                "Salare leggermente durante il soffritto.",
                "Aggiungere il latte e continuare la cottura a fuoco lento coperto.",
                "Cuocere fino a quando il latte sarà evaporato (eventualmente scoprire verso la fine per far evaporare l’acqua).",
                "Aggiungere il pesto in vasetto mischiandolo con un po' d’acqua per pulire bene il vasetto.",
                "Continuare la cottura a fuoco lento scoperto.",
                "Aggiungere un po' d’acqua in caso il pesto sia ancora grumoso e continuare la cottura.",
            ],
            notes: "Contorni consigliati: Patate lesse condite con olio d’oliva e origano.",
        },
        EN: {
            title: "Pesto Chicken",
            servings: "2 servings",
            ingredients: [
                "Two large chicken breasts",
                "A bit of milk",
                "Barilla Pesto (jar)",
                "Olive oil",
                "Salt",
            ],
            steps: [
                "Cut the chicken into slices that are not too thick or large (lightly pound if necessary to tenderize).",
                "Sauté with a bit of oil over medium heat until golden.",
                "Lightly salt during the sauté.",
                "Add the milk and continue cooking on low heat, covered.",
                "Cook until the milk has evaporated (uncover towards the end if necessary to evaporate the water).",
                "Add the jar of pesto, mixing it with a bit of water to clean the jar well.",
                "Continue cooking on low heat, uncovered.",
                "Add a bit of water if the pesto is still lumpy and continue cooking.",
            ],
            notes: "Recommended sides: Boiled potatoes seasoned with olive oil and oregano.",
        },
        PL: {
            title: "Kurczak z Pesto",
            servings: "2 porcje",
            ingredients: [
                "Dwie duże piersi z kurczaka",
                "Trochę mleka",
                "Pesto Barilla (słoik)",
                "Oliwa z oliwek",
                "Sól",
            ],
            steps: [
                "Pokrój kurczaka na plastry, które nie są zbyt grube ani duże (ewentualnie lekko rozbij, aby zmiękczyć).",
                "Podsmaż z odrobiną oliwy na średnim ogniu, aż będzie złoty.",
                "Lekko posól podczas podsmażania.",
                "Dodaj mleko i kontynuuj gotowanie na wolnym ogniu, pod przykryciem.",
                "Gotuj, aż mleko wyparuje (pod koniec odkryj, aby wyparować wodę, jeśli to konieczne).",
                "Dodaj słoik pesto, mieszając go z odrobiną wody, aby dobrze oczyścić słoik.",
                "Kontynuuj gotowanie na wolnym ogniu, bez przykrycia.",
                "Dodaj trochę wody, jeśli pesto jest nadal grudkowate, i kontynuuj gotowanie.",
            ],
            notes: "Zalecane dodatki: Gotowane ziemniaki z oliwą z oliwek i oregano.",
        },
    },
};
